import "./PerfectTrip.module.css";
import Header from "@/reusable_sections/Header";
import TravelDestinationsCarousel from "./sections/TravelDestinationsCarousel";
import SearchPromotions from "./sections/SearchPromotions";
import PromoInquiryForm from "./sections/PromoInquiryForm";
import TravelInquiryForm from "./sections/TravelInquiryForm";
import LoDelMomento from "./sections/LoDelMomento";
import CompraAhora from "./sections/CompraAhora";
import Footer from "@/reusable_sections/Footer";
import Cityscapehero from "./sections/Cityscapehero";
export default function PerfectTripPage() {
  return <div>
      <Header />
      <TravelDestinationsCarousel />
      <Cityscapehero />
      <PromoInquiryForm />
      <SearchPromotions />
      <TravelInquiryForm />
      <LoDelMomento />
      <CompraAhora />
      <Footer />
    </div>;
}